export default "__VITE_ASSET__U0_KnLPj__"